import {
  authService
} from '../../../base/services'

export const userAuthHeader = {
  'Authorization': `Bearer ${authService.getAccessToken()}`,
}